import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';

/** True when real Firebase credentials are present (i.e. web/.env is populated). */
export const IS_FIREBASE_CONFIGURED = Boolean(import.meta.env.VITE_FIREBASE_API_KEY);

// Only initialize the Firebase SDK when credentials are actually present.
// Calling getAuth() with apiKey: undefined throws auth/invalid-api-key at module
// load time, crashing every file that imports from this module and silently
// preventing the dev-mode bypass in AuthContext and api.ts from ever running.
let _app: FirebaseApp | undefined;
if (IS_FIREBASE_CONFIGURED) {
  const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
  };
  // Avoid re-initializing on HMR
  _app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
}

export const firebaseApp = _app;

// auth and db are only accessed in code paths guarded by IS_FIREBASE_CONFIGURED.
// The casts keep TypeScript happy without polluting call sites with null checks.
export const auth: Auth = IS_FIREBASE_CONFIGURED
  ? getAuth(_app!)
  : (null as unknown as Auth);

export const db: Firestore = IS_FIREBASE_CONFIGURED
  ? getFirestore(_app!)
  : (null as unknown as Firestore);
